import { useQuery } from "@tanstack/react-query";
import { fetchSite } from "@/lib/api";

export const useSite = () =>
  useQuery({ queryKey: ["site"], queryFn: fetchSite, staleTime: 60_000 });
